import { Dropdown, Search, Toggle } from '@silverfort/sf-components';
import useGetFilters from './useGetFilters';
import { useIspmContext } from '../IspmContext';

const InsightsTableFilter = () => {
    const {
        categories,
        setCategories,
        severitiesFilter,
        setSeveritiesFilter,
        setSearchedExposureName,
        searchedExposureName,
        showEmptyAndHiddenExposures,
        setShowEmptyAndHiddenExposures,
    } = useIspmContext();
    const filters = useGetFilters({ setSeveritiesFilter, severitiesFilter, setCategories, categories });


    return (
        <section className="flex justify-between items-center w-full h-fit">
            <div className="flex gap-6 items-center h-full">
                <div className="flex gap-2 items-center">
                    {filters?.map((filter) => {
                        return <Dropdown key={filter.title} {...filter} />;
                    })}
                </div>

                <div className="flex gap-2 items-center h-full">
                    <Toggle checked={showEmptyAndHiddenExposures} onChange={setShowEmptyAndHiddenExposures} className="m-0" />

                    <div className="text-13 text-sf-gray-800 font-sf">Show all exposures</div>
                </div>
            </div>

            <Search
                border={true}
                onChange={(value) => setSearchedExposureName(value)}
                placeholder="Search by Exposure"
                text={searchedExposureName}
            />
        </section>
    );
};

export default InsightsTableFilter;
